import { Pipe, PipeTransform } from '@angular/core';

interface CalculateAgeReturnType {
  years: number;
  months: number;
  days: number;
}

@Pipe({
  name: 'age',
  standalone: true,
})
export class AgePipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transform(value: unknown, ...args: unknown[]): unknown {
    const birthDate = new Date(<Date>value);
    const data = this.calculateAge(birthDate);
    const aux = [];
    if (data.years) {
      aux.push(`${data.years} años`);
    }

    if (data.months) {
      aux.push(`${data.months} meses`);
    }

    if (data.days) {
      aux.push(`${data.days} días`);
    }

    let rv = aux.join(' ').trim();
    if (rv === '' && this._isSameDate(birthDate, new Date())) {
      rv = '0 días';
    }

    return rv;
  }

  calculateAge(birthDate: Date): CalculateAgeReturnType {
    let years = 0,
      months = 0,
      days = 0;
    if (birthDate instanceof Date) {
      const today: Date = new Date();
      let age: number = today.getFullYear() - birthDate.getFullYear();
      const monthDiff: number = today.getMonth() - birthDate.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      years = age;
      months = (today.getMonth() + 12 - birthDate.getMonth()) % 12;
      days = today.getDate() - birthDate.getDate();
      if (days < 0) {
        months--;
        const prevMonthDays = new Date(
          today.getFullYear(),
          today.getMonth(),
          0
        ).getDate();
        days += prevMonthDays;
      }
    }

    const rv = { years, months, days };
    return rv;
  }

  private _isSameDate(date1: Date, date2: Date): boolean {
    const rv =
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();
    return rv;
  }
}
